<div class="infinity-logo-wrapper">
	<img class="infinity-logo" src="assets/images/homescreen/infinity_logo.svg" alt="Infinity Logo">
</div>
<div class="middle-box text-center loginscreen animated fadeInDown">
	<div>
		<div class="wcms-logo-wrapper">
			<img class="wcms-logo" src="assets/images/homescreen/infinity_wcms_logo_signet.svg" alt="WCMS Logo">
		</div>
		<h3>{{"oMisc.sWelcome"|translate}}</h3>

		<p>{{"oMisc.sWelcomeSubtitle"|translate}}</p>
		<tig-alert></tig-alert>
		<form class="form-with-bg" [formGroup]="OBJ_form_group" (ngSubmit)="onSubmit()" #OBJ_form="ngForm">
			<div class="form-group" [ngClass]="{ 'has-error': (OBJ_form.submitted || OBJ_form_group.get('username').touched) && !OBJ_form_group.get('username').valid }">
				<input type="email" class="form-control" placeholder="{{ 'oEmail.sPlaceholder' | translate }}" name="username" #username formControlName="username" />
				<div *ngIf="(OBJ_form.submitted || OBJ_form_group.get('username').touched) && !OBJ_form_group.get('username').valid">
					<div *ngIf="OBJ_form_group.get('username').hasError('required')" class="help-block">{{ "oEmail.sRequired" | translate }}</div>
					<div *ngIf="OBJ_form_group.get('username').value.length > 0 && OBJ_form_group.get('username').hasError('checkEmail')" class="help-block">{{ "oEmail.sInvalid" | translate }}</div>
				</div>
			</div>
			<div class="form-group" [ngClass]="{ 'has-error': (OBJ_form.submitted || OBJ_form_group.get('password').touched) && !OBJ_form_group.get('password').valid }">
				<input type="password" class="form-control" name="password" placeholder="{{ 'oPassword.sPlaceholder' | translate }}" #password formControlName="password" />
				<i [ngClass]="(password.type == 'password' ? 'fa fa-eye tig-eye' : 'fa fa-eye-slash tig-eye')" (click)="showPassword(password)"></i>
				<div *ngIf="(OBJ_form.submitted || OBJ_form_group.get('password').touched) && !OBJ_form_group.get('password').valid">
					<div *ngIf="OBJ_form_group.get('password').hasError('required')" class="help-block">{{  "oPassword.sRequired" | translate  }}</div>
					<div *ngIf="OBJ_form_group.get('password').value.length > 0 && OBJ_form_group.get('password').hasError('checkPassword')" class="help-block">{{ "oPassword.sInvalid" | translate }}</div>
				</div>
			</div>
			<button type="submit" class="btn btn-primary block full-width m-b btn-wcms-home" [disabled]="BOO_loading">{{"oLogin.sPlaceholder"|translate}}</button>
			<img *ngIf="BOO_loading" src="assets/images/loading.gif" />

			<a class="text-underline" href="#" [routerLink]="['/password-forgot']"><small>{{"oPassword.sForgot"|translate}}</small></a>
		</form>
		<p class="m-t"><small [innerHTML]="STR_company"></small></p>
	</div>
</div>
